__turbopack_context__.v({
  "collapsibleRow": "oZgCMa_collapsibleRow",
  "nativeCheckbox": "oZgCMa_nativeCheckbox",
  "sizeButton": "oZgCMa_sizeButton",
  "sizeButtonText": "oZgCMa_sizeButtonText",
  "sizeButtonsContainer": "oZgCMa_sizeButtonsContainer",
  "sizeFilterContents": "oZgCMa_sizeFilterContents",
});
